module.exports = __webpack_public_path__ + "img/App Containerization Services.54a87682.svg";